export const environment = {
	production: false,
	url: "https://api-crm.policystreet.app",
};
